import { useLayoutEffect, useState } from 'react';

import { Group } from '@visx/group';
import { Line } from '@visx/shape';

import useWerklijnen from '../../hooks/useWerklijnen';
import useMwdTimescale from '../../state/selectors/useMwdTimescale';
import { getCoordinates } from '../../utils/timescale';

const TwoAMTimeLine = ({ mini = false }: { mini?: boolean }) => {
  const { mwd } = useWerklijnen();
  const { scale, end, start } = useMwdTimescale(mini ? 'miniMwd' : 'mwd');

  const getTwoAMCoordinates = (daysOffset: number) => {
    const twoAM = new Date();
    twoAM.setDate(twoAM.getDate() + daysOffset);
    twoAM.setHours(2, 0, 0, 0);
    return getCoordinates({ start, end, scale }, twoAM).x;
  };

  const [timeOffsetsPx, setTimeOffsetsPx] = useState<number[]>([
    getTwoAMCoordinates(0),
    getTwoAMCoordinates(1),
    getTwoAMCoordinates(2),
  ]);

  useLayoutEffect(() => {
    const timeInterval = setInterval(() => {
      setTimeOffsetsPx([getTwoAMCoordinates(0), getTwoAMCoordinates(1), getTwoAMCoordinates(2)]);
    }, 1_000);
    return () => {
      clearInterval(timeInterval);
    };
  }, [start, end, scale]);

  return (
    <>
      {timeOffsetsPx.map((timeOffsetPx, index) => (
        // extra line to mask the grid line
        <Group key={`two-am-timeline-${timeOffsetPx}`} id={`2AM-timeline-${index}`}>
          <Line
            id={`2AM-timeline-${index}`}
            data-testid={`2AM-timeline-${index}`}
            stroke='var(--tractie-color-background-default)'
            strokeWidth={3}
            shapeRendering='crispEdges'
            from={{ x: timeOffsetPx, y: 0 }}
            to={{ x: timeOffsetPx, y: mwd.height + 8 }}
          />
          <Line
            data-testid={`2AM-timeline-${index}`}
            stroke='var(--tractie-color-border-emphasis)'
            strokeWidth={3}
            shapeRendering='crispEdges'
            from={{ x: timeOffsetPx, y: 0 }}
            to={{ x: timeOffsetPx, y: mwd.height + 8 }}
          />
        </Group>
      ))}
    </>
  );
};

export default TwoAMTimeLine;
